import { render, staticRenderFns } from "./CarrierGateway.vue?vue&type=template&id=b25e60f2"
import script from "./CarrierGateway.vue?vue&type=script&lang=js"
export * from "./CarrierGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports